import { Illustration } from "../Illustration.js";
import { useTranslation } from "react-i18next";
import { jsx } from "react/jsx-runtime";

//#region src/components/illustration/variants/DocumentsIllustration.tsx
const DocumentsIllustration = (props) => {
	const { t } = useTranslation("phx-lib");
	return /* @__PURE__ */ jsx(Illustration, {
		...props,
		svgFile: "documents.svg",
		alt: t("illustration.imageAlt.documentFolder")
	});
};

//#endregion
export { DocumentsIllustration };